import React from "react";

export type TDateIconProps = React.SVGAttributes<SVGElement>;

export function DateIcon({ ...rest }: TDateIconProps) {
  return (
    <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <mask id="mask0_2440_5363" mask-type="alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="26" height="26">
        <rect width="26" height="26" fill="#426377" />
      </mask>
      <g mask="url(#mask0_2440_5363)">
        <path d="M6 23C5.45 23 4.97917 22.8042 4.5875 22.4125C4.19583 22.0208 4 21.55 4 21V7C4 6.45 4.19583 5.97917 
          4.5875 5.5875C4.97917 5.19583 5.45 5 6 5H7V3H9V5H17V3H19V5H20C20.55 5 21.0208 5.19583 21.4125 5.5875C21.8042 
          5.97917 22 6.45 22 7V21C22 21.55 21.8042 22.0208 21.4125 22.4125C21.0208 22.8042 20.55 23 20 23H6ZM6 
          21H20V11H6V21ZM6 9H20V7H6V9ZM13 15C12.7167 15 12.4792 14.9042 12.2875 14.7125C12.0958 14.5208 12 14.2833 12 
          14C12 13.7167 12.0958 13.4792 12.2875 13.2875C12.4792 13.0958 12.7167 13 13 13C13.2833 13 13.5208 13.0958 
          13.7125 13.2875C13.9042 13.4792 14 13.7167 14 14C14 14.2833 13.9042 14.5208 13.7125 14.7125C13.5208 14.9042 
          13.2833 15 13 15ZM9 15C8.71667 15 8.47917 14.9042 8.2875 14.7125C8.09583 14.5208 8 14.2833 8 14C8 13.7167 
          8.09583 13.4792 8.2875 13.2875C8.47917 13.0958 8.71667 13 9 13C9.28333 13 9.52083 13.0958 9.7125 
          13.2875C9.90417 13.4792 10 13.7167 10 14C10 14.2833 9.90417 14.5208 9.7125 14.7125C9.52083 14.9042 9.28333 
          15 9 15ZM17 15C16.7167 15 16.4792 14.9042 16.2875 14.7125C16.0958 14.5208 16 14.2833 16 14C16 13.7167 
          16.0958 13.4792 16.2875 13.2875C16.4792 13.0958 16.7167 13 17 13C17.2833 13 17.5208 13.0958 17.7125 
          13.2875C17.9042 13.4792 18 13.7167 18 14C18 14.2833 17.9042 14.5208 17.7125 14.7125C17.5208 14.9042 17.2833 
          15 17 15ZM13 19C12.7167 19 12.4792 18.9042 12.2875 18.7125C12.0958 18.5208 12 18.2833 12 18C12 17.7167 
          12.0958 17.4792 12.2875 17.2875C12.4792 17.0958 12.7167 17 13 17C13.2833 17 13.5208 17.0958 13.7125 
          17.2875C13.9042 17.4792 14 17.7167 14 18C14 18.2833 13.9042 18.5208 13.7125 18.7125C13.5208 18.9042 13.2833 
          19 13 19ZM9 19C8.71667 19 8.47917 18.9042 8.2875 18.7125C8.09583 18.5208 8 18.2833 8 18C8 17.7167 8.09583 
          17.4792 8.2875 17.2875C8.47917 17.0958 8.71667 17 9 17C9.28333 17 9.52083 17.0958 9.7125 17.2875C9.90417 
          17.4792 10 17.7167 10 18C10 18.2833 9.90417 18.5208 9.7125 18.7125C9.52083 18.9042 9.28333 19 9 19ZM17 
          19C16.7167 19 16.4792 18.9042 16.2875 18.7125C16.0958 18.5208 16 18.2833 16 18C16 17.7167 16.0958 17.4792 
          16.2875 17.2875C16.4792 17.0958 16.7167 17 17 17C17.2833 17 17.5208 17.0958 17.7125 17.2875C17.9042 17.4792 
          18 17.7167 18 18C18 18.2833 17.9042 18.5208 17.7125 18.7125C17.5208 18.9042 17.2833 19 17 19Z"
          fill="#7F94A1" />
      </g>
    </svg>

  );
}
